export const collaboratorsDataPreparation = (data, { intl }) => {
  if (!data || !Array.isArray(data)) return []

  return data.map((item) => {
    if (!item) return {}

    const formattedDates = {}

    Object.keys(item).forEach((key) => {
      if (key.includes('fecha') && item[key] && intl?.formatDate) {
        formattedDates[key] = intl.formatDate(item[key])
      }
    })

    return {
      ...item,
      ...formattedDates,
    }
  })
}
